// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modals_modalOverlay__a8nbO","modal":"Modals_modal__QoxPA","modalTitle":"Modals_modalTitle__ir1zj","modalBody":"Modals_modalBody__BKnd0"};